module.exports = __webpack_public_path__ + "img/profile_background.f1dd518e.jpg";